// 2) Third-party libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 3.3 Project-specific modules � components/types
import { Role, RolesState } from "./types";

// 3.5 Redux actions / store
import type { RootState } from "../storeTypes";

const actionPrefix = 'role';

export const initialState: RolesState = {
	loading: false,
	allRoles: [],
	rolePermissions: {},
};

const roleSlice = createSlice({
	name: actionPrefix,
	initialState,
	reducers: {
		getAllRolesRequestAction: (state) => {
			state.loading = true;
		},
		getRolePermissionsSuccessAction: {
			reducer: (
				state,
				action: PayloadAction<{ data: {} }>
			) => {
				state.loading = false;
				state.rolePermissions = action.payload.data;
			},
			prepare: (data: {}) => {
				return {
					payload: {
						data
					}
				};
			}
		},
		getAllRolesSuccessAction: {
			reducer: (
				state,
				action: PayloadAction<{ data: Role[] }>
			) => {
				state.loading = false;
				state.allRoles = action.payload.data;
			},
			prepare: (data: Role[]) => {
				return {
					payload: {
						data
					}
				};
			}
		}
	},
});

const { actions, reducer } = roleSlice;

// Actions
export const {
	getAllRolesRequestAction,
	getRolePermissionsSuccessAction,
	getAllRolesSuccessAction
} = actions;

// Selectors
export const getRolePermissions = (state: RootState) => state.roles.rolePermissions;
export const getAllRoles = (state: RootState) => state.roles.allRoles;
export const getRolesLoading = (state: RootState) => state.roles.loading;

// Reducer
export default reducer;